// extracted by mini-css-extract-plugin
export default {"defaultBanner":"UserBanner_defaultBanner__-eo5f","banner":"UserBanner_banner__VEonX"};